<template>
  <svg :width="width" :height="height" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M6.92526 10.0002L3.69462 11.5761C3.13304 11.85 3.13304 12.6503 3.69462 12.9242L9.67142 15.8397C9.87895 15.941 10.1216 15.941 10.3291 15.8397L16.3059 12.9242C16.8674 12.6503 16.8674 11.85 16.3059 11.5761L13.0753 10.0002M6.92526 10.0002L3.69462 8.4242C3.13304 8.15025 3.13304 7.34998 3.69462 7.07604L9.67142 4.16052C9.87895 4.05929 10.1216 4.05929 10.3291 4.16052L16.3059 7.07604C16.8674 7.34998 16.8674 8.15025 16.3059 8.4242L13.0753 10.0002M6.92526 10.0002L9.67142 11.3397C9.87895 11.441 10.1216 11.441 10.3291 11.3397L13.0753 10.0002"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="square"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script>
export default {
  name: 'SameCreativeIcon',
  props: {
    width: {
      type: Number,
      default: 20
    },
    height: {
      type: Number,
      default: 20
    }
  }
}
</script>
